import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  HiOutlineFingerPrint,
  HiOutlineIdentification,
  HiOutlineEnvelope,
  HiOutlinePhone,
  HiOutlineWrenchScrewdriver,
  HiOutlineBuildingOffice,
  HiOutlineHandThumbUp,
  HiOutlineHandThumbDown,
  HiOutlineCog6Tooth,
  HiOutlineTrash,
  HiOutlinePlus,
  HiOutlineXMark,
} from "react-icons/hi2";

const AptitudesTecnicos = () => {
  const { id } = useParams();
  const { user } = useAuth();
  const [tecnico, setTecnico] = useState({});
  const [aptitudes, setAptitudes] = useState([]);
  const [open, setOpen] = useState(false);
  const [formDataAptitud, setFormDataAptitud] = useState({ id_tecnico: id, equipo: "", conocimiento: "" });
  const [maquinas, setMaquinas] = useState([]);

  useEffect(() => { fetchTecnico(); fetchAptitudes(); fetchMaquinas(); }, []);

  const fetchTecnico = async () => {
    try { const r = await axios.get(`https://desarrollotecnologicoar.com/api5/tecnicos/${id}`); setTecnico(r.data); }
    catch (err) { console.error("Error al obtener el tecnico:", err); }
  };

  const fetchAptitudes = async () => {
    try { const r = await axios.get(`https://desarrollotecnologicoar.com/api5/aptitudes/${id}`); setAptitudes(r.data); }
    catch (err) { console.error("Error al obtener aptitudes:", err); }
  };

  const fetchMaquinas = async () => {
    try { const r = await axios.get("https://desarrollotecnologicoar/api2/maquinas"); setMaquinas(r.data); }
    catch (e) { console.log("Error al cargar maquinas:", e); }
  };

  const agregarAptitud = async () => {
    try { await axios.post(`https://desarrollotecnologicoar.com/api5/aptitudes`, formDataAptitud); fetchAptitudes(); setOpen(false); }
    catch (err) { console.error("Error al agregar aptitud:", err); }
  };

  const borrarAptitud = async (id_aptitud) => {
    try { await axios.delete(`https://desarrollotecnologicoar.com/api5/aptitudes/${id_aptitud}`); fetchAptitudes(); }
    catch (err) { console.error("Error al eliminar aptitud:", err); }
  };

  const colorAptitudes = (c) => {
    if (c === "Avanzado") return "text-emerald-600";
    if (c === "Principiante") return "text-red-500";
    return "text-amber-500";
  };

  const infoItems = [
    { icon: HiOutlineFingerPrint, label: "ID", value: tecnico.id },
    { icon: HiOutlineIdentification, label: "Nombre", value: tecnico.nombre_tecnico },
    { icon: HiOutlineEnvelope, label: "Correo", value: tecnico.correo_tecnico },
    { icon: HiOutlinePhone, label: "Telefono", value: tecnico.telefono },
    { icon: HiOutlineWrenchScrewdriver, label: "Puesto", value: tecnico.puesto },
    { icon: HiOutlineBuildingOffice, label: "Sucursal", value: tecnico.sucursal },
  ];

  return (
    <div className="page-container">
      <h1 className="page-title text-center mb-6">Control de aptitudes para {tecnico.nombre_tecnico}</h1>

      <div className="card overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          {/* Left: Tech info */}
          <div className="flex-1 p-5">
            <h2 className="section-title mb-4">Informacion general</h2>
            <div className="space-y-3">
              {infoItems.map((item, i) => (
                <div key={i} className="flex items-center gap-3 text-sm">
                  <item.icon className="w-5 h-5 text-slate-400 shrink-0" />
                  <span className="text-slate-500 w-20">{item.label}</span>
                  <span className="font-medium text-slate-800">{item.value}</span>
                </div>
              ))}
              <div className="flex items-center gap-3 text-sm">
                {tecnico.estatus === "Activo" ? (
                  <HiOutlineHandThumbUp className="w-5 h-5 text-emerald-500 shrink-0" />
                ) : (
                  <HiOutlineHandThumbDown className="w-5 h-5 text-red-500 shrink-0" />
                )}
                <span className="text-slate-500 w-20">Estatus</span>
                <span className={`font-medium ${tecnico.estatus === "Activo" ? "text-emerald-600" : "text-red-500"}`}>{tecnico.estatus}</span>
              </div>
            </div>
          </div>

          {/* Right: Aptitudes */}
          <div className="flex-1 p-5 bg-blue-50 border-l border-blue-100">
            <h2 className="section-title mb-4">Aptitudes</h2>
            {aptitudes.length === 0 ? (
              <p className="text-sm text-slate-400">No se encontraron aptitudes para este tecnico.</p>
            ) : (
              <div className="space-y-2 max-h-80 overflow-y-auto">
                {aptitudes.map((apt) => (
                  <div key={apt.id} className="flex items-center justify-between p-2 bg-white rounded-lg border border-slate-100">
                    <div className="flex items-center gap-2">
                      <HiOutlineCog6Tooth className="w-5 h-5 text-slate-400" />
                      <span className="font-medium text-slate-800 text-sm">{apt.equipo}:</span>
                      <span className={`text-sm font-semibold ${colorAptitudes(apt.conocimiento)}`}>{apt.conocimiento}</span>
                    </div>
                    <button onClick={() => borrarAptitud(apt.id)} className="btn-icon text-red-400 hover:text-red-600">
                      <HiOutlineTrash className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
            <div className="text-center mt-4">
              <button onClick={() => setOpen(true)} className="text-xs py-1.5 px-4 inline-flex items-center gap-1.5 bg-emerald-600 text-white rounded-btn font-semibold hover:bg-emerald-700 transition-colors">
                <HiOutlinePlus className="w-4 h-4" /> Agregar Aptitud
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {open && (
        <>
          <div className="overlay" onClick={() => setOpen(false)} />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="modal w-full max-w-md">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold text-slate-900">Agregar Aptitud</h3>
                <button onClick={() => setOpen(false)} className="btn-icon"><HiOutlineXMark className="w-5 h-5" /></button>
              </div>
              <div className="space-y-3">
                <div>
                  <label className="label">Equipo</label>
                  <select value={formDataAptitud.equipo} onChange={(e) => setFormDataAptitud({ ...formDataAptitud, equipo: e.target.value })} className="input">
                    <option value="">-- Selecciona --</option>
                    {maquinas.map((m) => <option key={m.id} value={m.maquina}>{m.maquina}</option>)}
                  </select>
                </div>
                <div>
                  <label className="label">Conocimiento</label>
                  <select value={formDataAptitud.conocimiento} onChange={(e) => setFormDataAptitud({ ...formDataAptitud, conocimiento: e.target.value })} className="input">
                    <option value="">-- Selecciona --</option>
                    <option value="Avanzado">Avanzado</option>
                    <option value="Intermedio">Intermedio</option>
                    <option value="Principiante">Principiante</option>
                  </select>
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-6">
                <button onClick={() => setOpen(false)} className="btn-secondary">Cancelar</button>
                <button onClick={agregarAptitud} className="btn-primary">Agregar</button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AptitudesTecnicos;
